'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from 'contexts/InAppProvider';
import { TopTenPage } from 'app/(appHeader)/promotions/2026-pick-and-choo/top10/TopTenPage';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  return <TopTenPage isApp={isApp} />;
}
